import { render, staticRenderFns } from "./approvedloanrequests.vue?vue&type=template&id=32573b16&scoped=true"
import script from "./approvedloanrequests.vue?vue&type=script&lang=js"
export * from "./approvedloanrequests.vue?vue&type=script&lang=js"
import style0 from "./approvedloanrequests.vue?vue&type=style&index=0&id=32573b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32573b16",
  null
  
)

export default component.exports